import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VideoPopupComponent {
  @Input() videoSrc;
  constructor(public modalCtrl: ModalController) {}

  public dismissOverlay() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }
}
